import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { apiErr } from "../SuperHeader";

export default function SettingsTab({ cid, detail, reload }) {
  const co = detail.company;
  const [f, setF] = useState({ name: co.name, industry: co.industry || "", plan: co.plan || "trial", is_test: !!co.is_test });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.name.trim().length < 2) return toast.error("Company name must be at least 2 characters");
    setBusy(true);
    try { await api.patch(`/admin/companies/${cid}`, { ...f, name: f.name.trim(), industry: f.industry.trim() }); toast.success("Settings saved"); reload(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <Card className="p-5 border-slate-200 max-w-xl space-y-4" data-testid="settings-tab">
      <div className="space-y-1"><label className="text-sm font-medium">Company name</label><Input value={f.name} maxLength={120} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="settings-name" /></div>
      <div className="space-y-1"><label className="text-sm font-medium">Industry</label><Input value={f.industry} maxLength={80} onChange={(e) => setF({ ...f, industry: e.target.value })} data-testid="settings-industry" /></div>
      <div className="space-y-1"><label className="text-sm font-medium">Plan</label>
        <Select value={f.plan} onValueChange={(v) => setF({ ...f, plan: v })}>
          <SelectTrigger data-testid="settings-plan"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">{["trial", "starter", "professional", "business"].map((p) => <SelectItem key={p} value={p} className="capitalize">{p}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200">
        <div><div className="text-sm font-medium">Test / demo tenant</div><div className="text-xs text-slate-500">Labels this company as test data on the dashboard</div></div>
        <Switch checked={f.is_test} disabled={co.is_demo} onCheckedChange={(v) => setF({ ...f, is_test: v })} data-testid="settings-is-test" />
      </div>
      <Button onClick={save} disabled={busy} className="bg-indigo-600 hover:bg-indigo-700" data-testid="settings-save">{busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Save settings</Button>
    </Card>
  );
}
